import script from "./CinemaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CinemaView.vue?vue&type=script&setup=true&lang=js"

import "./CinemaView.vue?vue&type=style&index=0&id=413e9c66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413e9c66"]])

export default __exports__